export default __webpack_public_path__ + "static/media/sample.d597a204.pdf";